import type { QuoteDocument } from 'paintscout'

export const PREVIEW_QUOTE_ID = 'preview'

export interface SampleEstimator {
  name: string
  title: string
  description: string
}

/** True for the sample quote `getPresentationPreviewQuote` builds to preview a template */
export function isPreviewQuote(quote?: Pick<QuoteDocument, '_id'> | null) {
  return quote?._id === PREVIEW_QUOTE_ID
}

/**
 * Dummy estimator for the template preview, where the sample quote has no real estimator. Named
 * after the sample quote's owner so it matches the sales rep the Work Order block shows.
 */
export function getSampleEstimator(quote?: Pick<QuoteDocument, 'owner'> | null): SampleEstimator {
  const firstName = quote?.owner?.firstName?.trim()
  const lastName = quote?.owner?.lastName?.trim()
  const name = [firstName, lastName].filter(Boolean).join(' ') || 'Your Estimator'

  return {
    name,
    title: 'Estimator',
    description:
      `<p>Hi, I'm ${firstName || 'your estimator'}. I help homeowners plan their painting projects, ` +
      `from colour choices to the final walkthrough.</p>` +
      `<p><em>Sample text. Each estimator's own photo and description from their profile appear here.</em></p>`
  }
}
